import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportLogAcessoSistemaUseCase } from "../../../presentation/useCases/read/get_report_log_acesso_sistema_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportLogAcessoSistemaUseCase
 */

export class GetReportLogAcessoSistemaUseCase implements IGetReportLogAcessoSistemaUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(
    requiredMimeType: ReportMimeType | null,
    idUsuario: number,
    dataDe: Date | null,
    dataAte: Date | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportLogAcessoSistema(requiredMimeType, idUsuario, dataDe, dataAte);


    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = `log_acesso_sistema_Lista_${new Date().toISOString()}.${response.filenameExtension}`

      await downloadBase64File(arquivoNome, arquivoData);
    }


    return response;
  }

}
